import { Tooltip } from '@/components/ui/Tooltip'
import { waitingOn, type PayoutViewer, type WaitingLine } from '@/lib/payout-waiting'
import { cn } from '@/lib/utils'

/**
 * Waar deze uitbetaalregel op wacht, als zin. Geen pill-vlak: het label is geen
 * statuswoord meer maar een korte zin, en die leest in een chip als een knop.
 * De dot draagt de kleur, zoals bij elke andere statusweergave.
 */
export function PayoutWaitingLabel({
  line,
  viewer = 'admin',
  className,
}: {
  line: WaitingLine
  viewer?: PayoutViewer
  className?: string
}) {
  const { label, hint, dot, text } = waitingOn(line, viewer)

  const body = (
    <span className={cn('inline-flex min-w-0 items-center gap-1.5 text-xs font-medium', text, hint && 'cursor-help', className)}>
      <span className={cn('h-1.5 w-1.5 shrink-0 rounded-full', dot)} />
      <span className="truncate">{label}</span>
    </span>
  )

  return hint ? <Tooltip content={hint}>{body}</Tooltip> : body
}
